export const UserAccountStatusType = {
  ACTIVE: 'ACTIVE',
  RESTRICTED: 'RESTRICTED',
  BANNED: 'BANNED',
};

export const userAccountStatusTypes = [
  UserAccountStatusType.ACTIVE,
  UserAccountStatusType.RESTRICTED,
  UserAccountStatusType.BANNED,
];
